import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import * as React from "react";

export const CommentIcon = (props: SvgIconProps) => {
    const { viewBox = "0 0 20 20", ...rest } = props;

    return (
        <SvgIcon viewBox={viewBox} {...rest}>
            <g>
                <path
                    fill="#21006E"
                    d="M10,1.1C4.5,1.1,0,4.8,0,9.2c0,1.4,0.5,2.8,1.3,4l-0.4,4.6c0,0.3,0.1,0.6,0.4,0.8c0.2,0.1,0.3,0.2,0.5,0.2
		c0.1,0,0.3,0,0.4-0.1l4.3-2c1.2,0.4,2.4,0.5,3.6,0.5c5.5,0,10-3.6,10-8.1C20,4.8,15.5,1.1,10,1.1z M10,16.1c-0.7,0-1.5-0.1-2.2-0.2
		c-0.2,0-0.4-0.1-0.6-0.1c-0.1,0-0.1,0-0.2-0.1l-0.1,0c-0.2,0-0.3-0.1-0.5-0.2l-0.1,0l-4.2,1.9l0.4-4.6l0-0.1
		c-0.1-0.1-0.2-0.3-0.3-0.4c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.2-0.2-0.4-0.3-0.6C1.4,10.8,1.3,10,1.3,9.2c0-3.8,3.9-6.9,8.7-6.9
		s8.7,3.1,8.7,6.9S14.8,16.1,10,16.1z"
                />
                <rect x="5.6" y="7.2" fill="#21006E" width="8.8" height="1.3" />
                <rect x="5.6" y="10" fill="#21006E" width="5.9" height="1.3" />
            </g>
        </SvgIcon>
    );
};
